import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { get, find, filter } from 'lodash';
import moment from 'moment';
import Hint from 'components/common/Hint';

import helpers from 'utils/helpers';
import { orderPickupRequest, voidPickupRequest } from 'ducks/shipments';
import { StyledButton, NextButton, AddressDisplay } from 'components/Styled';
import DateForm from './DateForm';
import countries from 'data/countries';

class Pickup extends Component {
  dateForm = React.createRef();
  handleNext = () => {
    window.dataLayer.push({
      event: 'Submit Pickup',
      ecommerce: undefined
    });

    let success = true;

    if (!success) {
      return helpers.scrollToError();
    }

    const dateForm = this.dateForm.current.getFormData();

    this.props.orderPickupRequest({
      dateForm,
      orderRef: this.props.orderRef
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.pickupSuccess && this.props.pickupSuccess) {
      const dateForm = this.dateForm.current.getFormData();
      this.props.handleNext({
        dateForm,
        orderRef: this.props.orderRef,
        shipmentData: this.props.shipmentData,
        pickupData: this.props.pickupData,
        paperlessImageUrl: this.props.paperlessImageUrl
      });
    }
  }

  componentDidMount() {
    this.setState({
      formStartTime: moment()
    });

    window.dataLayer.push({
      event: 'Land Pickup Page',
      ecommerce: undefined,
      landPickup: JSON.stringify({
        origin: this.props.origin,
        destination: this.props.destination
      })
    });

    this.props.handler.openPopup(filter(this.props.posts, ['page', 'PICKUP']));

    if (this.props.pickupSuccess && !this.props.orderProcessPorcessing) {
      this.props.voidPickupRequest({ orderRef: this.props.orderRef });
    }
  }

  render() {
    if (this.props.redirect) {
      return null;
    }



    return (
      <div
        className="quotation-content"
        style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <div style={{ flex: '1 0 auto' }}>
          <div
            className="blank-background buttonTheme-color"
            style={{
              color: '#57D7DD',
              fontSize: '24px',
              fontWeight: 700,
              backgroundColor: '#f5f5f5',
              padding: '15px'
            }}>
            {this.props.t('pickup.title')}
          </div>
          <div
            style={{
              padding: '25px 15px 15px'
            }}>
            <Row type="flex" align="bottom">
              <Col span={12}>
                <span
                  className="blank-background buttonTheme-color"
                  style={{
                    color: '#57D7DD',
                    fontSize: '24px',
                    fontWeight: 700
                  }}>
                  {get(
                    find(this.props.countries, ['alpha-2', this.props.origin]),
                    `name.${this.props.t('key')}`
                  )}
                </span>{' '}
                <span
                  style={{
                    color: '#2C2C2E'
                  }}>
                  {this.props.t('pickup.form.pickup_title')}
                  <Hint
                    msg={this.props.t('pickup.hints.inbound_hint')}
                    visible={this.props.origin !== 'HK'}
                  />
                </span>
              </Col>
              <Col span={12}></Col>
            </Row>
            <AddressDisplay>
              <Row type="flex" align="middle" gutter={14}>
                <Col span={8}>
                  <div style={{ fontWeight: 700, color: '#2C2C2E' }}>
                    {this.props.shipmentData.fromAddress.name}
                  </div>
                  <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                    {this.props.shipmentData.fromAddress.phoneCc
                      ? `+${this.props.shipmentData.fromAddress.phoneCc} `
                      : ''}
                    {this.props.shipmentData.fromAddress.phone}
                  </div>
                </Col>
                <Col span={16}>
                  <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                    <div>
                      {this.props.shipmentData.fromAddress.city ||
                        this.props.shipmentData.fromAddress.area}
                    </div>
                    <div>
                      {this.props.shipmentData.fromAddress.street1}
                      {this.props.shipmentData.fromAddress.street2
                        ? '\n' + this.props.shipmentData.fromAddress.street2
                        : null}
                      {this.props.shipmentData.fromAddress.street3
                        ? '\n' + this.props.shipmentData.fromAddress.street3
                        : null}
                    </div>
                    {this.props.shipmentData.fromAddress.company ? (
                      <div>{this.props.shipmentData.fromAddress.company}</div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </AddressDisplay>
          </div>
          <div
            className="blank-background buttonTheme-color"
            style={{
              color: '#57D7DD',
              fontSize: '24px',
              fontWeight: 700,
              backgroundColor: '#f5f5f5',
              height: '5px'
            }}></div>
          <div
            style={{
              padding: '15px'
            }}>
            <DateForm
              t={this.props.t}
              loading={this.props.loading}
              country={this.props.origin}
              carrier={this.props.carrier}
              selectedService={this.props.selectedService}
              availableData={this.props.availableData}
              boxData={this.props.boxData}
              ref={this.dateForm}
            />
          </div>
        </div>
        <div>
          <NextButton
            block
            step="true"
            type="primary"
            height={60}
            onClick={this.handleNext}
            loading={this.props.loading}>
            {this.props.t('button.next_step')}
          </NextButton>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.shipments.loading,
    pickupData: state.shipments.pickupData || {},
    pickupSuccess: !!state.shipments.pickupSuccess,
    orderProcessPorcessing: !!state.shipments.orderProcessPorcessing,
    user: state.auth.user || false,
    shipmentData: state.shipments.shipmentData || {},
    paperlessImageUrl: state.shipments.paperlessImageUrl || {},
    recoverFormData: state.shipments.recoverFormData || {},
    posts: state.shipments.posts || false,
    countries: state.shipments.countries || countries
  };
};

const mapDispatchToProps = {
  orderPickupRequest,
  voidPickupRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Pickup)
);
